import { render, staticRenderFns } from "./SelfOnboardBanner.vue?vue&type=template&id=493b6ad1&scoped=true"
import script from "./SelfOnboardBanner.vue?vue&type=script&lang=js"
export * from "./SelfOnboardBanner.vue?vue&type=script&lang=js"
import style0 from "./SelfOnboardBanner.vue?vue&type=style&index=0&id=493b6ad1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493b6ad1",
  null
  
)

export default component.exports